import { CanvasQuality } from "../Shared/GeneratedTypes";
import { LiveSwitchState } from "../Shared/sharedTypes";
import { LiveSwitchAction, sendPhotoDeletedCommand } from "./liveSwitchActions";
import * as types from "./liveSwitchActionTypes";

export const initialState = {
    guestSessionActive: false,
    locallyRecording: false,
    audioMuted: false,
    clientAudioMuted: false,
    videoMuted: false,
    sessionId: null,
    remoteVideoDevices: [],
    localVideoDevices: [],
    localAudioInputs: [],
    localAudioOutputs: [],
    clientRegistered: false,
    cameraBusy: false,
    confirmAudioMute: false,
    confirmVideoMute: false,
    confirmCameraSelection: null,
    showClientConnectionQualityWarning: false,
    canvasQuality: CanvasQuality.High,
} as LiveSwitchState;

export default function sessionStatusReducer(state = initialState, action: LiveSwitchAction): LiveSwitchState {
    switch (action.type) {
        case types.REMOTE_VIDEO_DEVICE_LIST_RECEIVED:
            return { ...state, remoteVideoDevices: action.videoDevices };
        case types.LOCAL_VIDEO_DEVICE_LIST_RECEIVED: {
            return { ...state, localVideoDevices: action.videoDevices };
        }
        case types.LOCAL_AUDIO_INPUT_LIST_RECEIVED: {
            return { ...state, localAudioInputs: action.audioInputs };
        }
        case types.LOCAL_AUDIO_OUTPUT_LIST_RECEIVED: {
            return { ...state, localAudioOutputs: action.audioOutputs };
        }
        case types.SET_GUEST_ACTIVE_STATE: {
            return { ...state, guestSessionActive: action.active };
        }
        case types.TOGGLE_LOCAL_AUDIO: {
            return { ...state, audioMuted: !state.audioMuted };
        }
        case types.TOGGLE_LOCAL_VIDEO: {
            return { ...state, videoMuted: !state.videoMuted };
        }
        case types.CLIENT_AUDIO_MUTE_UPDATED: {
            return { ...state, clientAudioMuted: action.muted };
        }
        case types.NETWORK_STATUS_UPDATED: {
            return { ...state, clientRegistered: action.connected };
        }
        case types.SET_CAMERA_BUSY_STATUS: {
            return { ...state, cameraBusy: action.busy };
        }
        case types.AUDIO_MUTE_CONFIRMATION_STATE_UPDATED: {
            return { ...state, confirmAudioMute: action.confirmationNeeded };
        }
        case types.VIDEO_MUTE_CONFIRMATION_STATE_UPDATED: {
            return { ...state, confirmVideoMute: action.confirmationNeeded };
        }
        case types.CHANGE_CAMERA_CONFIRMATION_UPDATED: {
            return { ...state, confirmCameraSelection: action.deviceId };
        }
        case types.ISSUE_CLIENT_CONNECTION_QUALITY_WARNING: {
            return { ...state, showClientConnectionQualityWarning: true };
        }
        case types.CANCEL_CLIENT_CONNECTION_QUALITY_WARNING: {
            return { ...state, showClientConnectionQualityWarning: false };
        }
        case types.SET_LOCAL_AUDIO_OUTPUT: {
            return {
                ...state,
                localAudioOutputs: state.localAudioOutputs.map((o) =>
                    o.id == action.id ? { ...o, selected: true } : { ...o, selected: false }
                ),
            };
        }
        case types.SET_LOCAL_VIDEO_INPUT: {
            return {
                ...state,
                localVideoDevices: state.localVideoDevices.map((v) =>
                    v.id == action.id ? { ...v, selected: true } : { ...v, selected: false }
                ),
            };
        }
        case types.SET_LOCAL_AUDIO_INPUT: {
            return {
                ...state,
                localAudioInputs: state.localAudioInputs.map((a) =>
                    a.id == action.id ? { ...a, selected: true } : { ...a, selected: false }
                ),
            };
        }
        case types.SEND_CANVAS_QUALITY_COMMAND: {
            return { ...state, canvasQuality: action.quality };
        }
    }
    return state;
}
